import { objectOf, string, shape, func, bool, number, oneOfType } from 'prop-types'

const configPropTypes = {
    apiRoot: string,
    engineSearch: shape({
        liveRead: objectOf(string),
        preRecorded: objectOf(string)
    }),
    urlApiPropTypes: shape({
        advertiser: string,
        baseUrl: string,
        checkToken: string,
        folder: string,
        graphql: string,
        listFolder: string,
        searchBar: string,
        updateToken: string
    })
}

const functionAdvertiserPropTypes = {
    cancel: func,
    next: func,
    edit: bool,
    onSave: func,
    back: func,
}

const advertiserPropTypes = shape({
    activeStep: number.isRequired,
    advertiser_id: oneOfType([string, number]),
    loaded: bool,
    loading: bool
})


export {
    configPropTypes,
    functionAdvertiserPropTypes,
    advertiserPropTypes
}